import {
  StockMessage
} from '~/views/StockMessage';
import Layout from "~/layout/index.vue";

const StockMessageRoutes = {
  path: '/stock',
  component: Layout,
  children: [
    {
      path: '',
      name: 'stockMessage',
      component: StockMessage,
      meta: {
        title: '库存管理',
        isBack: true,
        isHeaderShow: true
      }
    }
  ]
}

export {
  StockMessageRoutes
}
